import { ColoredIcon } from "@msuite/ui/icons";
import { guardString } from "@msuite/utils/strings";
import type { Enums } from "@msuite/utils/types";

/** Props Interface */
export interface TicketSelectItemProps {
	number: string;
	description: string;
	icon: Enums<"iconName"> | undefined;
	color: Enums<"color"> | undefined;
}

/**
 * One ticket as a select option: its number on its own line above, its type's icon beside its
 * description below.
 *
 * The number leads because it is what a ticket is called out loud and the only part of the row
 * that is short enough to read at a glance; the description is the sentence that tells the two
 * tickets of a type apart, so it takes the icon's line rather than competing with the number.
 *
 * The icon and colour come from the ticket's type, which is why both are optional here — a ticket
 * whose type was deleted still has to render, and `ColoredIcon` carries the fallback for it.
 */
export function TicketSelectItem({ number, description, icon, color }: TicketSelectItemProps) {
	/** Render */
	return (
		<div className="v-stack">
			<p className="label">#{number}</p>
			<div className="h-stack">
				<ColoredIcon
					iconName={icon}
					color={color}
				/>
				<p className="truncate">{guardString(description)}</p>
			</div>
		</div>
	);
}
